import { useCallback, useLayoutEffect, useState } from 'react';
let installedHost = null;
export function installDesktopRegionHost(host) {
    installedHost = host;
}
function useDesktopRegionOnDesktop(kind, { active = true, expanded = false } = {}) {
    const host = installedHost;
    const [key] = useState(() => ({}));
    useLayoutEffect(() => {
        host?.report(key, { kind, active, expanded });
        return () => host?.removeReport(key);
    }, [host, key, kind, active, expanded]);
    const ref = useCallback((element) => {
        host?.attach(key, element);
    }, [host, key]);
    return { ref, presentation: host?.presentation(kind) ?? null };
}
const NO_REGION = { ref: () => { }, presentation: null };
export const useDesktopRegion = import.meta.env.VITE_IS_PERPLEXITY_DESKTOP_BUILD
    ? useDesktopRegionOnDesktop
    : () => NO_REGION;
//# sourceMappingURL=desktopRegion.js.map